/* ReBrandMD — shared interactions */
(function(){
  // Mobile menu
  var burger = document.getElementById('burger');
  var links  = document.getElementById('navlinks');
  if(burger && links){
    burger.addEventListener('click', function(){ links.classList.toggle('open'); });
    links.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        // on mobile, dropdown parents expand instead of navigating away
        if(window.innerWidth <= 980){
          var item = a.closest('.nav-item');
          if(item && a.parentElement === item && item.querySelector('.dropdown')){
            // toggle submenu when tapping the top-level label
          }
        }
        links.classList.remove('open');
      });
    });
  }
  // Mobile dropdown expand
  document.querySelectorAll('.nav-item > a').forEach(function(top){
    top.addEventListener('click', function(e){
      if(window.innerWidth <= 980 && top.parentElement.querySelector('.dropdown')){
        e.preventDefault();
        top.parentElement.classList.toggle('exp');
      }
    });
  });

  // Accordions (FAQ / etc.)
  document.querySelectorAll('.acc-q').forEach(function(q){
    q.addEventListener('click', function(){
      var item = q.parentElement;
      var a = item.querySelector('.acc-a');
      var open = item.classList.contains('open');
      var siblings = item.parentElement.querySelectorAll('.acc-item');
      siblings.forEach(function(i){ i.classList.remove('open'); i.querySelector('.acc-a').style.maxHeight = null; });
      if(!open){ item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  // Reveal on scroll
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold:.12 });
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  // Count-up animation for stat numbers
  document.querySelectorAll('.stat .num').forEach(function(el){
    var raw = el.textContent.trim();
    var m = raw.match(/^(\D*)(\d+)(\D*)$/);
    if(!m){ return; }
    var pre = m[1], target = parseInt(m[2],10), suf = m[3], done = false;
    var ob = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting && !done){
          done = true;
          var start = null, dur = 1100;
          var step = function(ts){
            if(!start){ start = ts; }
            var p = Math.min((ts-start)/dur, 1);
            el.textContent = pre + Math.round(p*target) + suf;
            if(p < 1){ requestAnimationFrame(step); }
          };
          requestAnimationFrame(step);
        }
      });
    }, { threshold:.5 });
    ob.observe(el);
  });

  // Sticky CTA bar — reveal after the hero, hide near the footer
  var sticky = document.querySelector('.sticky-cta');
  if(sticky){
    var foot = document.querySelector('footer.site');
    var onScroll = function(){
      var past = window.scrollY > 600;
      var nearFoot = foot && (foot.getBoundingClientRect().top < window.innerHeight + 80);
      sticky.classList.toggle('show', past && !nearFoot);
    };
    window.addEventListener('scroll', onScroll, { passive:true });
    onScroll();
  }

  // Parallax — gentle scroll movement on framed/feature images
  var px = [].slice.call(document.querySelectorAll('[data-parallax]'));
  if(px.length && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)){
    var ticking=false;
    var run=function(){
      var vh=window.innerHeight;
      px.forEach(function(el){
        var r=el.getBoundingClientRect();
        if(r.bottom<-120 || r.top>vh+120) return;
        var amt=parseFloat(el.getAttribute('data-parallax'))||16;
        var prog=((r.top+r.height/2)-vh/2)/vh;
        var y=Math.max(-amt, Math.min(amt, -prog*amt));
        el.style.transform='translateY('+y.toFixed(1)+'px) scale(1.08)';
      });
      ticking=false;
    };
    window.addEventListener('scroll',function(){ if(!ticking){ requestAnimationFrame(run); ticking=true; } },{passive:true});
    run();
  }

  // Product plan selector (subscribe / one-time) → updates the Add button's plan
  document.addEventListener('click', function(e){
    var pp = e.target.closest('[data-pp]');
    if(!pp) return;
    var box = pp.closest('.plan-pick'); if(!box) return;
    box.querySelectorAll('[data-pp]').forEach(function(x){ x.classList.remove('on'); });
    pp.classList.add('on');
    var btn = document.getElementById(box.getAttribute('data-addbtn'));
    if(btn) btn.setAttribute('data-plan', pp.getAttribute('data-pp'));
  });
})();
